import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Storia from "@/components/Storia";
import MenuSection from "@/components/MenuSection";
import InstagramSection from "@/components/InstagramSection";
import Lombate from "@/components/Lombate";
import Recensioni from "@/components/Recensioni";
import Galleria from "@/components/Galleria";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import AdminMenu from "@/pages/AdminMenu";
import AdminPhotos from "@/pages/AdminPhotos";
import AdminReviews from "@/pages/AdminReviews";
import AdminQr from "@/pages/AdminQr";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Storia />
        <MenuSection />
        <InstagramSection />
        <Lombate />
        <Recensioni />
        <Galleria />
        <Contatti />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="protected-route-loading" className="min-h-screen flex items-center justify-center bg-[#0D0C0A]">
        <p className="font-cinzel tracking-[0.3em] text-xs uppercase text-[#C9A265]">Verifica accesso...</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App" data-testid="app-root">
      <div className="grain-overlay" />
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="/admin/menu" element={<ProtectedRoute><AdminMenu /></ProtectedRoute>} />
              <Route path="/admin/foto" element={<ProtectedRoute><AdminPhotos /></ProtectedRoute>} />
              <Route path="/admin/recensioni" element={<ProtectedRoute><AdminReviews /></ProtectedRoute>} />
              <Route path="/admin/qr" element={<ProtectedRoute><AdminQr /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#171512",
            border: "1px solid rgba(201,162,101,0.35)",
            color: "#FAF7F2",
          },
        }}
      />
    </div>
  );
}
